import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProgramList.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import VoiceAttributeEditForm from '../../VoiceAttributeEditForm/VoiceAttributeEditForm';
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import "../../../moreCore/UI/Tabbing/PageStack";
import RadioGroup from '../../../moreCore/UI/RadioGroup/RadioGroup';
import "../../../moreCore/UI/RadioGroup/RadioGroup";
import { TranslationHelpers } from "../../../more/Helpers";
import EvProgramEditor from '../../EvProgram/EvProgramEditor';

class EvProgramList extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;
    private opusInput: MdsLax<InstanceType<typeof HintBox>>;
    //private isRedEntry: CheckBox;
    private opusRedInput_Author: MdsLax<InstanceType<typeof Edit>>;
    private opusRedInput_Title: MdsLax<InstanceType<typeof Edit>>;
    private opusRedInput_Duration: MdsLax<InstanceType<typeof NumberInput>>;

    private opusInputContainer: HTMLElement;
    //private redEntryInputContainer: HTMLElement;
    private addRedEntryButton: HTMLButtonElement;
    private addEntryPagestack: MdsLax<InstanceType<typeof PageStack>>;

    private sectionAddEntry: HTMLElement;
    private syncInfoMessage: HTMLElement;


    private showSyncOption: boolean = false;
    private inputSyncMode: MdsLax<InstanceType<typeof RadioGroup>>;
    private syncModeContainer: HTMLElement;


    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvProgram>>>;


    private evBookingId: string;

    private entitylist: Array<any>;

    private tableLayout: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "duration_min"],
        colNamesInternal: ["c_composer_author", "c_opus", "duration_min"],
        "colspans": [1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programDurationHeader"]],
        widths: [null, null, "10ch"],
        alignmentsHeading: [null, null, null],
        alignmentsRow: [null, null, null]
    }

    private tableLayout_status: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "duration_min", "ref_ev_program_status.description"],
        colNamesInternal: ["c_composer_author", "c_opus", "duration_min", "ref_ev_program_status.description"],
        "colspans": [1, 1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programDurationHeader"], (this as any).translations["General_Label_Status"]],
        widths: [null, null, "10ch", null],
        alignmentsHeading: [null, null, null, null],
        alignmentsRow: [null, null, null, null],
        bgColors: [null, null, null, "ref_ev_program_status.coloration"]
    }

    private tableLayout_om: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min"],
        colNamesInternal: ["c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min"],
        "colspans": [1, 1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programInstrumentation"], (this as any).translations["BookingEditor__programDurationHeader"]],
        widths: [null, null, null, "10ch"],
        alignmentsHeading: [null, null, null, null],
        alignmentsRow: [null, null, null, null]
    }

    private tableLayout_om_status: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min", "ref_ev_program_status.description"],
        colNamesInternal: ["c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min", "ref_ev_program_status.description"],
        "colspans": [1, 1, 1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programInstrumentation"], (this as any).translations["BookingEditor__programDurationHeader"], (this as any).translations["General_Label_Status"]],
        widths: [null, null, null, "10ch", null],
        alignmentsHeading: [null, null, null, null, null],
        alignmentsRow: [null, null, null, null, null],
        bgColors: [null, null, null, null, "ref_ev_program_status.coloration"]
    }

    private _onClick_TableRowAction(
        pEntity: any,
        rowIndex: number,
        actionType: "delete" | "edit" | "moveup" | "movedown" | "download" | "editInstrumentation",
        row: any = null,
        evt: any
    ): void {


        if (actionType == "editInstrumentation") {
            //console.log(pEntity);

            let entity = pEntity as VAM2types.EvProgram;

            let form = new VoiceAttributeEditForm();
            form.setData(entity);

            

            let dlg = new GenericDialog();
            dlg.callback = lang.hitch(this, function (form: MdsLax<InstanceType<typeof VoiceAttributeEditForm>>, rowIndex: number, result) {
                if (result <= 0) return;

                let changedData = form.getChangedData();

                //console.log("changedData", changedData);
                let modifiedEntity = lang.mixin(entity, changedData);
                //this.checkIsFormDirty();
                this.store.changeEntry(modifiedEntity);

            }, form, rowIndex);

            dlg.show(form, this.getTranslation("BookingEditor__programEditInstrumentation") + " ( " + entity.c_opus + " )", null, null, "okcancel");


            return;
        }
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.EvProgram>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;


        this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_opus);

        //cell.formattingHandled = true;
        let icon = null;
        switch (colName) {
            //case "TXT_EvProgram_Display_cast":

            //    if (entity["is_red_entry"] || (entity as VAM2types.EvProgram).ref_opus == null) {
            //        node.innerHTML = "";
            //    } else {
            //        let instrumentationTooltip = new Tooltip();
            //        instrumentationTooltip.setup({
            //            content: value,
            //            targetnode: node,
            //            enableHover: true,
            //            heading: ""
            //        });

            //        let instrumentationEditIcon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "&nbsp;", node);
            //        on(instrumentationEditIcon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "editInstrumentation", cell.tableRow));

            //        node.append(value);

            //        return true;
            //    }

            //    break;
            //case "Aktionen":
            //case "castAktionen":
            //case "prgAktionen":
            //    icon = this.createFontawesomeIcon("fas fa-chevron-circle-up hoverTxtPrimary secondaryText w3-margin-right", "", node);
            //    on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "moveup", cell.tableRow));
            //    icon = this.createFontawesomeIcon("fas fa-chevron-circle-down hoverTxtPrimary secondaryText w3-margin-right", "", node);
            //    on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "movedown", cell.tableRow));

            //    icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText", "", node);
            //    on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
            //    return true;
            //    break;
            default:
                return false;
        }
    }
    private _onChange_StoreData() {

        if (!this.table) {
            this.setupTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);
        if (this.store.isDirty()) {
            this._delayEmit();
        }
    }

    private _emitHandle: any = null;
    private _delayEmit() {
        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.getData()), 20);

    }
    //private _onChangeIsRedEntry(): void {
    //    let isRed = this.isRedEntry.getValue();
    //    this.hideNode(this.redEntryInputContainer, !isRed);
    //    this.hideNode(this.opusInputContainer, isRed);
    //}
    private _onChangeOpusInput(): void {
        let value = this.opusInput.getValue() as VAM2types.Opus;

        if (value != null) {
            let fakeEntity: Partial<VAM2types.EvProgram> = {
                ID: (Math.random() * 100000).toString(),
                $Displayname: `${value.gDisp_opus} - ${value.gDisp_composer_author}`,
                ref_opus: value,
                c_composer_author: value.gDisp_composer_author,
                c_opus: value.opus_titel,
                duration_min: value.duration_min
            }
            
            this.store.addEntry(fakeEntity as any);

            this.opusInput.setValue(null, true);
        }
    }

    private _onChangeRedInput(value: any): void {
        let readyCheck = this.opusRedInput_Author.getValue() &&
            this.opusRedInput_Title.getValue() &&
            (this.opusRedInput_Duration.getValue() != null || !this.hasFeature("EvProgram/DurationIsMandatory"));

        this.disableNode(this.addRedEntryButton, !readyCheck);
    }

    private _onClickAddRedEntryButton(): void {
        this.disableNode(this.addRedEntryButton, true);       

        let fakeEntity: Partial<VAM2types.EvProgram> = {
            ID: (Math.random() * 100000).toString(),

            c_composer_author: this.opusRedInput_Author.getValue(),
            c_opus: this.opusRedInput_Title.getValue(),
            duration_min: this.opusRedInput_Duration.getValue(),
            //ref_opus: null
        }

        this.store.addEntry(fakeEntity as any);

        this.opusRedInput_Author.setValue(null, true);
        this.opusRedInput_Duration.setValue(null, true);
        this.opusRedInput_Title.setValue(null, true);
    }

    private _onChange_SyncMode(value) {
        if (this.showSyncOption) {
            this._delayEmit();
        }
        this.store.rollback();
        this._handleSyncModeDisplayStyle();

        this.setupTable();

    }

    private _handleSyncModeDisplayStyle() {
        let mode: VAM2types.EvBookingSyncMode = this.inputSyncMode.getValue();

        this.inputSyncMode.setReadonly(!this.hasUserRole("EvProgram_Edit"));

        this.hideNode(this.syncModeContainer, !this.showSyncOption);
        this.hideNode(this.syncInfoMessage, !this.showSyncOption);

        this.hideNode(this.addEntryPagestack, mode == VAM2types.EvBookingSyncMode.synced);
        this.UiModder.domAttr.set(this.syncInfoMessage, "innerHTML", TranslationHelpers.translate(mode == VAM2types.EvBookingSyncMode.individual ? "EvProgram_InfoText__SyncModeIndividual" : "EvProgram_InfoText__SyncedFromEvProject"))

    }

    getData(): { entitylist: Array<VAM2types.EvProgram>, syncMode: VAM2types.EvBookingSyncMode } {
        return {
            entitylist: this.store.getCurrentCompleteList(),
            syncMode: this.inputSyncMode.getValue() as VAM2types.EvBookingSyncMode
        };
    }
    getDiffData() {
        let diffData = this.store.getDiffData(true);
        return diffData;
    }

    private setupTable(): void {

        this.tableContainer.innerHTML = null;

        let bEdit = this.hasUserRole("EvProgram_Edit");
        let bDelete = this.hasUserRole("EvProgram_Delete");

        if (this.showSyncOption == true && this.inputSyncMode.getValue() == VAM2types.EvBookingSyncMode.synced) {
            bEdit = false;
            bDelete = false;
        }
       
        this.table = new StaticTable();

        if (bEdit) {
            this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
            this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditButton));
        }
        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));

        if (bDelete) this.table.addDefaultRowActionButton("delete");//, lang.hitch(this, this._onRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);
        if (this.hasFeature("Planning/EvProgramStatus")) this.table.addLineConfig(this.hasUserRole(["OM", "EvBooking_OM"]) ? this.tableLayout_om_status : this.tableLayout_status);
        else this.table.addLineConfig(this.hasUserRole(["OM", "EvBooking_OM"]) ? this.tableLayout_om : this.tableLayout);

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);
        this.table.setCyAttribute("evProgrammList");
    }  

    private _onClickEditButton(data: StaticTable.StaticTableRowGroup<VAM2types.EvProgram>) {
        let programEditor = new EvProgramEditor();
        programEditor.on("confirmed", lang.hitch(this, this._onEditoConfirmed));
        programEditor.setup(data.entity);
    }

    private _onEditoConfirmed(data: VAM2types.EvProgram) {
        this.store.changeEntry(data, true);
    }

    private _onClick_OpenEvProgramSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvProgram_EvBooking",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            { bookingID: this.evBookingId }
        );

    }

    private _onCallback_Dlg(mode: string, data, items) {
        if (!items || !items.length) return;

        for (let item of items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        let entity = {
            ID: item.entry.value, gDisp_1: item.entry.label
        }

        if (mode == "selectEvProgram_EvBooking") {
            this.opusInput.setValue(item.entry.data);
        }
            //this.previousSEDvalue = items;
        }
    }

    setup(data: Array<VAM2types.EvProgram>, evBookingId: string, syncMode?: VAM2types.EvBookingSyncMode) {
        this.store.setup(data, "ID");
        this.evBookingId = evBookingId;
        this.entitylist = data;

        if (typeof (syncMode) != "undefined") {
            this.inputSyncMode.setValue(syncMode, true);
            // change beim Setup einmal unterdrücken und sich selber um den Style kümmern:
            this._handleSyncModeDisplayStyle();

        }

        this.setupTable();

    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.opusInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvProgramSED));

        this.hideNode(this.sectionAddEntry, !this.hasUserRole("EvProgram_Create"));


        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.showSyncOption = this.hasFeature("EvProject/EvProgram");
        this._handleSyncModeDisplayStyle();

        if (this.showSyncOption) {
            on(this.inputSyncMode, "change", lang.hitch(this, this._onChange_SyncMode));
        }



    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProgramList);